<template>
  <div class="main-index">
    <div class="header">
      <div class="login" v-show="userInfo===''" data-track-text="H5登录" aria-label="H5登录" @click="toPath('/h5/login')">
        登录
      </div>
      <div class="login" v-show="userInfo!==''">
        <el-dropdown @command="logOut" v-if="showloginOut"
                     style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #f5f5f5">
            <span v-show="userInfo!==''" class="title_hide"
                  style="overflow-x: hidden;text-overflow: ellipsis;width: 100px;white-space: nowrap;">
              {{ userInfo }}
            </span>
          <el-dropdown-menu v-if="showloginOut" slot="dropdown">
            <el-dropdown-item command="toCenter" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">充值中心</span>
            </el-dropdown-item>
            <el-dropdown-item command="toManyou" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">开通漫游<img src="../../assets/new_icon.png" alt=""></span>
            </el-dropdown-item>
            <el-dropdown-item command="toAccount" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">个人设置</span>
            </el-dropdown-item>
            <el-dropdown-item style="z-index: 1;font-weight: 800">
              <span style="font-size: 22px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span data-track-text="个人中心" aria-label="个人中心" @click="toCenter">
            <img v-if="userType==='0'" class="user-img" src="../../assets/img/person_no.png" alt="">
            <img v-if="userType==='1'" class="user-img" src="../../assets/img/child_no.png" alt="">
            <img v-if="userType==='2'" class="user-img" src="../../assets/img/roaming_no.png" alt="">
          </span>
      </div>
      <div v-if="groupUserInfo==='机构登录'" class="login" data-track-text="H5机构登录" aria-label="H5机构登录" @click="toPath('/h5/login')">
        <span>机构登录</span>
      </div>
      <div v-if="groupUserInfo!=='机构登录'"
           style="overflow-x: hidden;text-overflow: ellipsis;width: 130px;white-space: nowrap;" class="login">
        <el-dropdown @command="logOut" v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                     style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;background: #f5f5f5">
          <span v-show="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                style="overflow-x: hidden;text-overflow: ellipsis;width: 130px;white-space: nowrap;" class="title_hide">{{
              groupUserInfo
            }}</span>
          <el-dropdown-menu v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'" slot="dropdown">
            <el-dropdown-item v-for="(item,index) in groupUserInfos" :key="index" :command="item.name"
                              style="z-index: 1;font-weight: 800">
                <span style="font-size: 20px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">{{
                    item.name
                  }}</span>
              <span
                  style="margin-left:10px; font-size: 20px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;"
                  v-if="!item.isIpScore">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="select" style="font-size: 24px;font-family: Source Han Sans CN;font-weight: 400;color: #333333;">
        {{
          this.$route.name === 'Trans' ? '立即翻译' : this.$route.name === 'TransPro' && isShowTransPro ?
              '人工翻译' : this.$route.name === 'Convert' ? 'PDF转换' : this.$route.name === 'List' ? '历史文档' : ''
        }}
      </div>
      <div class="select">
        <div @click="showSelect=!showSelect" class="select-option" data-track-text="展开导航菜单" aria-label="展开导航菜单">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-show="showSelect" class="selected">
        <div data-track-text="H5导航首页" aria-label="H5导航首页" @click="toPath('/h5/index')">首页</div>
        <div data-track-text="H5导航立即翻译" aria-label="H5导航立即翻译" @click="toPath('/h5/trans')">立即翻译</div>
        <div data-track-text="H5导航人工翻译" aria-label="H5导航人工翻译" @click="toPath('/h5/trans-pro')" v-if="isShowTransPro">人工翻译</div>
        <div data-track-text="H5导航PDF转换" aria-label="H5导航PDF转换" @click="toPath('/h5/convert')">PDF转换</div>
        <div data-track-text="H5导航历史文档" aria-label="H5导航历史文档" @click="toPath('/h5/list')">历史文档</div>
      </div>
    </div>
    <router-view></router-view>
    <div class="main-foot" style="flex-flow: column">
      <div>
        © 2020 北京容智科技发展有限公司 京ICP备19036872号-3 All
        rights reserved. 京公网安备 11011402010815号
      </div>
      <div style="margin-top: 10px">
        <a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询">联系邮箱：info@wiseivy.com.cn</a>
        <span style="margin-left: 15px">联系电话：010-80755328</span>
      </div>
    </div>
  </div>
</template>

<script>
import {authServiceClient, translateServiceClient} from "@/tools/api/service";
import {outRequest, thirdLoginRequest, userStatusRequest} from "@/tools/api/auth-api";
import {uploadTipRequest} from "@/tools/api/translate-api";

export default {
  name: "Index",
  data() {
    return {
      showSelect: false,
      isShowInRoaming: false,
      isShowTransPro: false,
      groupUserInfo: '',
      groupUserInfos: [],
      userId: '',
      userType: '',
      userInfo: '',
      showloginOut: false,
    }
  },
  created() {
    this.getUploadTip()
    const TOKEN_KEY = 'token';
    authServiceClient.getUserStatus(userStatusRequest, {
      [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
    }).then(res => {
      if (!res.getStatus()) {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.groupUserInfo = "";
        this.showRoaming = false;
        return;
      }
      const user = localStorage.getItem('auth-context');
      if (!user) {
        return
      }
      const userJson = JSON.parse(user);
      const Base64 = require('js-base64').Base64;
      userJson.forEach(item => {
        if (item.type === 'Person' || item.type === 'Child') {
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          if (item.type === 'Person') {
            this.userType = '0'
          }
          if (item.type === 'Child') {
            this.userType = '1'
          }
          this.userInfo = realName
          this.userId = item.name;
          if (!item.isRoaming) {
            let roaming = localStorage.getItem(this.userId)
            if (!roaming || roaming !== '1') {
              this.showRoaming = true
            } else {
              this.showRoaming = false
              this.userType = '2'
            }
          } else {
            this.userType = '2'
          }
          if (this.groupUserInfo === '') {
            this.groupUserInfo = '机构登录';
          }
          this.showloginOut = true
        }
        if (item.type === 'Group') {
          this.groupUserInfos.push(item)
          let realName = '';
          if (item.realName !== '' && item.realName !== undefined) {
            realName = Base64.decode(item.realName);
          } else {
            realName = item.name;
          }
          this.groupUserInfo = realName;
          this.url = process.env.VUE_APP_WEB_LOGIN_URL;
        }
      })
    }).catch(err => {
      localStorage.removeItem("token")
      localStorage.removeItem("auth-context")
      this.userInfo = "";
      this.showRoaming = false
    });
  },
  mounted() {
    const code = this.getUrlParameter(this.$route.fullPath).code;
    const state = this.getUrlParameter(this.$route.fullPath).state;
    if (code !== undefined && code !== null && code !== "") {
      this.checkLogin(code, state);
    }
  },
  methods: {
    toCenter() {
      window.open("https://user.wesitrans.com/account", '_blank')
    },
    getUrlParameter(route) {
      let url = decodeURIComponent(route).split('?');
      url = url[url.length - 1];
      let obj = {};
      url.split('&').map((query) => {
        let temp = query.split('=');
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    logOut(val) {
      if (val === "toAccount") {
        if (val === "toCenter") {
          window.open("https://user.wesitrans.com", '_blank')
          return;
        }
        window.open("https://user.wesitrans.com/account", '_blank')
        return;
      }
      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo)
      } else {
        request.setName(val)
      }
      const TOKEN_KEY = 'token';
      authServiceClient.logOut(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        window.location.reload();
        this.$router.push("/h5/index")
      }).catch(err => {
        localStorage.removeItem("token")
        localStorage.removeItem("auth-context")
        this.userInfo = "";
        this.showRoaming = false
        this.$router.push("/h5/login")
      });
    },
    checkLogin(code, state) {
      let request = thirdLoginRequest;
      request.setCode(code)
      request.setState(state)
      const TOKEN_KEY = 'token';
      authServiceClient.thirdLogin(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
      }).then(res => {
        let status = res.getStatus();
        if (status === "400") {
          this.$message({
            center: true,
            type: 'error',
            showClose: true,
            duration: 3000,
            message: res.getMessage()
          });
          setTimeout(this.toNew, 3000);
          return;
        }
        if (status === "201") {
          let openid = res.getOpenid();
          let type = res.getType();
          this.$router.push({
            name: "Bind",
            params: {openid: openid, type: type}
          })
          return;
        }
        if (status === "200") {
          this.$router.push("/h5/index")
          window.location.reload()
        }
      }).catch(err => {
        this.$message({
          center: true,
          type: 'error',
          showClose: true,
          duration: 3000,
          message: "登录失败请重试"
        });
      })
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      translateServiceClient.getUploadTip(uploadTipRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      }).then(res => {
        this.isShowInRoaming = res.getIsRoaming();
        this.isShowTransPro = res.getIsTransPro();
      }).catch(err => {
        this.isShowInRoaming = false;
        this.isShowTransPro = true;
      });
    },
    toPath(path) {
      this.showSelect = false
      this.$router.push(path)
    },
  }
}
</script>

<style lang="less" scoped>
.main-index {
  min-width: 768px;

  .header {
    width: 100%;
    height: 88px;
    background: #E6E6E6;
    display: flex;

    .title_hide {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      background: #e6e6e6;
    }

    .login {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      align-items: center;
      display: flex;
      height: 100%;
      margin-left: 33px;
    }

    .selected {
      position: fixed;
      width: 201px;
      height: 372px;
      background: #FFFFFF;
      box-shadow: 0px 5px 10px 0px rgba(116, 114, 114, 0.51);
      z-index: 100;
      top: 90px;
      right: 31px;
      text-align: center;

      div {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 72px;
      }
    }

    .select {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 1;
      margin-right: 30px;

      .select-option {
        width: 48px;
        height: 11px;
        display: flex;

        div {
          height: 11px;
          width: 11px;
          background: #333333;
          margin-left: 5px;
          border-radius: 50%;
        }
      }

    }
  }

  .main-foot {
    height: 149px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 667px;
      height: 64px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233E;
      line-height: 36px;
    }
  }
}

</style>
